export default "__VITE_ASSET__DdeVvCk$__"